import styled from 'styled-components';

export const CustomCard = styled.div`
  /* Adapt the colors based on active prop */
  background-color: #677adb;
  opacity: ${props => (props.status === '1' ? '.5' : '1')};
`;
